import {defineStore, storeToRefs} from 'pinia';
import {useUserStore} from './userStore';
import {useBookingForAllowedQuery} from '../api/queries/queries/booking/useBookingForAllowedQuery';
import {computed, ref, watch} from 'vue';

export const useBookingForStore = defineStore('bookingFor', () => {
    const {user, isAuthenticated} = storeToRefs(useUserStore());
    const userMeBookingForId = ref<string | null>(user.value?.id ?? null);

    const enabled = computed(() => isAuthenticated.value && !!user.value?.id);
    const {data: usersMeBookingForAllowed} = useBookingForAllowedQuery(enabled);

    watch(user, user => {
        userMeBookingForId.value = user ? user.id : null;
    });

    const isSelfBooking = computed<boolean>(() => {
        return userMeBookingForId.value === user.value?.id;
    });

    const userMeBookingFor = computed(
        () =>
            usersMeBookingForAllowed.value.find(user => user.id === userMeBookingForId.value) ??
            null
    );

    type BookingMode = 'self' | 'other';

    const bookingMode = computed<BookingMode>(() => {
        if (isSelfBooking.value) {
            return 'self';
        }
        return 'other';
    });

    function handleUserSelect(userId: string | null) {
        userMeBookingForId.value = userId;
    }

    /**
     * The effective id -> only set when the user is not booking for himself
     */
    const effectiveBookingForId = computed(() => userMeBookingFor.value?.id ?? null);

    return {
        userMeBookingForId,
        userMeBookingFor,
        usersMeBookingForAllowed,
        isSelfBooking,
        handleUserSelect,
        bookingMode,
        effectiveBookingForId,
    };
});
